import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "text-sm text-black-lp-200",
    key: _ctx.timer
  }, _toDisplayString(_ctx.timer), 1))
}